export default "__VITE_ASSET__Ce6AO0t9__"